import React, { FunctionComponent, useRef } from 'react';
import styles from './SecondAuthentication.module.scss';
import TextInput from 'app/components/Form/Inputs/TextInput';
import { _t } from 'app/utils/i18n';
import { getSearchState } from 'app/utils/search-state';
import { useMutation } from 'react-query';
import { twoFactorLogin } from 'auth/Requests';
import ReCAPTCHA from 'react-google-recaptcha';
import { useCustomForm } from 'app/hooks/useCustomForm';
import { codeValidationSchema } from '../validationSchema';
import { useHistory } from 'react-router-dom';
import { path } from 'app/utils/path';
import { useAuth } from 'app/context/auth';
import { checkIsMockGoogleRecaptcha } from 'app/utils/check-mock-google-recaptcha';

const SecondAuth: FunctionComponent = () => {
  const reRef = useRef<ReCAPTCHA>();
  const auth = useAuth();
  const { user_id, remember_me } = getSearchState();
  // const [isLoading, setIsloading] = useState(false);
  const twoFactorLoginAsync = useMutation(twoFactorLogin);
  const history = useHistory();

  const {
    handleSubmit,
    changeHandler,
    formState: { errors },
  } = useCustomForm(codeValidationSchema, {});

  const onSubmit = async (values: any) => {
    let token = '';
    if (checkIsMockGoogleRecaptcha()) {
      token = await reRef.current.executeAsync();
      reRef.current.reset();
    }
    await twoFactorLoginAsync
      .mutateAsync({ Data: { code: values?.second_auth_code, user_id }, token })
      .then((res: any) => {
        if (res?.code === 200) {
          auth.login({
            ...res?.payload?.records,
            remember_me: remember_me,
          });
          history.replace(path.home);
        }
      });
  };

  return (
    <>
      {checkIsMockGoogleRecaptcha() && (
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY as any}
          size="invisible"
          ref={reRef as any}
        />
      )}
      <div className={styles.SignIn}>
        <div className={styles.MODAl}>
          <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
            <div className={styles.top}>
              <p>{_t('login:Enter_a_verification_code')}</p>
              <span>{_t('login:verification')}</span>
            </div>
            <div className={`${styles.field}`}>
              <div className={styles.field_top}>
                <span>{_t('login:Invalid_code')}</span>
              </div>
              <TextInput
                type="text"
                name="second_auth_code"
                onChange={(e) => changeHandler('second_auth_code', e)}
                error={errors?.second_auth_code?.message}
              />
            </div>
            <div className={styles.flexWrapper}>
              <button>{_t('login:Verify')}</button>
              <a
                onClick={() => history.push(path.auth.SIGN_IN)}
                className="cursor-pointer"
              >
                {_t('return_sign_in')}
              </a>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default SecondAuth;
